export default "__VITE_ASSET__DXvo7Pm2__"